import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/ContactMessage';
// FOR ONE GRAPHQL QUERY
export const ADD_MESSAGE = defineAsyncActionTypes(`${prefix}/ADD_MESSAGE`);



// WEBPACK FOOTER //
// ./src/store/graphql/ContactMessage/action-types.js